import { Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { InvoiceRateTypes, invoiceRateTypes } from '@parkchirp/reporting';
import { useCallback } from 'react';

type Props = {
	selectedRateTypes: InvoiceRateTypes[];
	onChange: (value: InvoiceRateTypes[]) => void;
};

export const InvoiceRateTypesFilter = ({ selectedRateTypes, onChange }: Props) => {
	const allSelected = selectedRateTypes?.length === invoiceRateTypes.length;

	const selectAll = useCallback(() => {
		onChange([...invoiceRateTypes]);
	}, [onChange]);

	const clear = useCallback(() => {
		onChange([]);
	}, [onChange]);

	const rateTypeMapper = useCallback(
		(rateType: InvoiceRateTypes) => {
			switch (rateType) {
				case 'Monthly':
					return 'Monthly';
				case 'Validation':
					return 'Validation & Other Types';
				default:
					return 'Monthly';
			}
		},
		[invoiceRateTypes],
	);

	const handleRateTypeChange = useCallback(
		(rateType: InvoiceRateTypes, checked: boolean) => {
			if (checked) {
				onChange([...selectedRateTypes, rateType]);
				return;
			}

			onChange(selectedRateTypes.filter((selected) => selected !== rateType));
		},
		[onChange, selectedRateTypes],
	);

	return (
		<Stack spacing={2}>
			<Stack direction='row' justifyContent='space-between' alignItems='center'>
				<Typography variant='subtitle1' fontWeight={600}>
					Rate types
				</Typography>

				<Stack direction='row' spacing={1}>
					<Button size='small' variant='text' onClick={selectAll} disabled={allSelected}>
						Select all
					</Button>
					<Button size='small' variant='text' onClick={clear} disabled={selectedRateTypes.length === 0}>
						Clear
					</Button>
				</Stack>
			</Stack>

			<Stack direction='row' flexWrap='wrap' columnGap={3} rowGap={1}>
				{invoiceRateTypes.map((rateType) => (
					<FormControlLabel
						key={rateType}
						control={
							<Checkbox
								checked={selectedRateTypes.includes(rateType)}
								onChange={(event) => handleRateTypeChange(rateType, event.target.checked)}
							/>
						}
						label={rateTypeMapper(rateType)}
					/>
				))}
			</Stack>
		</Stack>
	);
};
